module.exports = __webpack_public_path__ + "static/how-to-share__fb-f918ed33bde00e26174b269f4f24807c.jpg";